<div #container *ngIf="session || showSessionId">
  <div
    [innerHTML]="session.html | safeHtml"
    *ngIf="session && !solutionMode; else fromSessionId"
  ></div>
  <ng-template #fromSessionId>
    <akit-exercise
      *ngIf="showSessionId"
      [attr.session-id]="showSessionId"
      [attr.review-mode]="reviewMode ? 'true' : 'false'"
      [attr.solution-mode]="solutionMode ? 'true' : 'false'"
    >
    </akit-exercise>
  </ng-template>
</div>
